import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["disabled"];
import PaymentItem from "./PaymentItem.vue";
import BNPLPayment from "./BNPLPayment.vue";
import Cash from "./Cash.vue";
import ErrorMessage from "../../form/ErrorMessage.vue";
import resettableValue from "../../../tools/resettable_value";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentList',
    props: /*@__PURE__*/ _mergeModels({
        systems: Array,
        cashConfig: Object,
        error: String,
        sum: Number,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, "modelValue");
        const errorMessage = resettableValue(() => props.error, value);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("fieldset", {
                disabled: __props.sum === 0,
                class: _normalizeClass(["form-group form-group--list always-visible", { 'has-error': _unref(errorMessage) }])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.systems, (system) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (system.type === 'sberbank_bnpl')
                            ? (_openBlock(), _createBlock(BNPLPayment, {
                                key: 0,
                                system: system,
                                disabled: system.disabled,
                                sum: __props.sum,
                                "action-name": "chastyami_info",
                                modelValue: value.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                            }, null, 8 /* PROPS */, ["system", "disabled", "sum", "modelValue"]))
                            : (system.type === 'dolyame')
                                ? (_openBlock(), _createBlock(BNPLPayment, {
                                    key: 1,
                                    system: system,
                                    disabled: system.disabled,
                                    sum: __props.sum,
                                    "action-name": "dolyame_info",
                                    modelValue: value.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((value).value = $event))
                                }, null, 8 /* PROPS */, ["system", "disabled", "sum", "modelValue"]))
                                : (system.type === 'podeli')
                                    ? (_openBlock(), _createBlock(BNPLPayment, {
                                        key: 2,
                                        system: system,
                                        disabled: system.disabled,
                                        sum: __props.sum,
                                        "action-name": "podeli_info",
                                        modelValue: value.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((value).value = $event))
                                    }, null, 8 /* PROPS */, ["system", "disabled", "sum", "modelValue"]))
                                    : (system.type === 'cash')
                                        ? (_openBlock(), _createBlock(Cash, {
                                            key: 3,
                                            system: system,
                                            config: __props.cashConfig,
                                            sum: __props.sum,
                                            modelValue: value.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((value).value = $event))
                                        }, null, 8 /* PROPS */, ["system", "config", "sum", "modelValue"]))
                                        : (_openBlock(), _createBlock(PaymentItem, {
                                            key: 4,
                                            system: system,
                                            modelValue: value.value,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((value).value = $event))
                                        }, null, 8 /* PROPS */, ["system", "modelValue"]))
                    ], 64 /* STABLE_FRAGMENT */));
                }), 256 /* UNKEYED_FRAGMENT */)),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(ErrorMessage, {
                    error: _unref(errorMessage),
                    class: "col"
                }, null, 8 /* PROPS */, ["error"])
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
